import { render } from "./ToolbarContent.vue?vue&type=template&id=37a9f577"
import script from "./ToolbarContent.vue?vue&type=script&lang=js"
export * from "./ToolbarContent.vue?vue&type=script&lang=js"
script.render = render

export default script